import { navigate } from "../../services";
import { BTN_MEDIUM, Button, ButtonGroup, TYPE_FAILURE } from "../../lib";

export default function LogoutLink() {
    return (
        <ButtonGroup>
            <Button
                type={TYPE_FAILURE}
                size={BTN_MEDIUM}
                margin="0px auto 80px auto"
                messageId="menu.logout"
                onClick={() => navigate.to("/app/logout")}
            />
        </ButtonGroup>
    );
}
